import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchDeleteOrganizationFromProject = async (
  projectId,
  organizationChartItemIdToDelete
) => {
  const apiPath = `organization-charts/project/${projectId}/delete-organization-from-project`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: { organizationChartItemIdToDelete },
  });

  const response = await axios(signedRequest);

  return response.data;
};
